import { createContext } from 'react';

const medication_reminderContext = createContext();

export default medication_reminderContext;
